<template>
  <v-container>
    <v-app>
      <v-app-bar
        :clipped-left="$vuetify.breakpoint.lgAndUp"
        app
        color="lotojr_colorPrimary"
        dark
      >
        <div class="d-flex align-center" style="margin-right: 50px;">
          <v-img
            :src="require('../../assets/rsz_logo.png')"
            class="my-3"
            contain
            width="100"
          />
        </div>
      </v-app-bar>
      <v-layout justify-center align-center>
        <v-card
          class="card-rounded center"
          min-width="350"
          max-width="750"
          outlined
        >
          <v-form
            @submit.prevent="resetPassword"
            ref="resetPassForm"
            lazy-validation
          >
            <v-card-title class="signup-title">Recuperar Senha</v-card-title>
            <v-card-text style="padding-top: 6px;">
              <v-row>
                <v-col cols="12" class="signup-form-input">
                  <v-text-field
                    label="Nova Senha"
                    id="password"
                    :disabled="loading || disabledFields"
                    :loading="loading"
                    v-model="password"
                    :rules="passwordRules"
                    :append-icon="
                      showPassword ? 'visibility' : 'visibility_off'
                    "
                    @click:append="showPassword = !showPassword"
                    :type="showPassword ? 'text' : 'password'"
                    required
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="signup-form-input">
                  <v-text-field
                    label="Confirme a Senha"
                    id="confirmPassword"
                    v-model="confirmPassword"
                    :disabled="loading || disabledFields"
                    :loading="loading"
                    :rules="confirmPasswordRules"
                    :append-icon="
                      showConfirmPassword ? 'visibility' : 'visibility_off'
                    "
                    @click:append="showConfirmPassword = !showConfirmPassword"
                    :type="showConfirmPassword ? 'text' : 'password'"
                    required
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                :disabled="loading || disabledFields"
                text
                type="submit"
                >Salvar</v-btn
              >
            </v-card-actions>
          </v-form>
          <app-notification></app-notification>
        </v-card>
      </v-layout>
    </v-app>
  </v-container>
</template>
<script>
import Notification from "../../components/Notification";
export default {
  components: {
    "app-notification": Notification,
  },
  data() {
    return {
      valueResetPassword: {},
      password: null,
      confirmPassword: null,
      urlPassword: null,
      showPassword: false,
      showConfirmPassword: false,
      loading: false,
      disabledFields: true,
      passwordRules: null,
      confirmPasswordRules: null,
    };
  },
  created() {
    this.urlPassword = this.$route.query.h;
    this.createRules();
    this.getResetUrl();
  },

  methods: {
    resetForm() {
      if (this.$refs.resetPassForm) {
        this.$refs.resetPassForm.reset();
      }
    },
    createRules() {
      this.passwordRules = [
        (v) => !!v || "Senha é obrigatória",
        (v) =>
          (v && v.length >= 6) || "A senha deve conter ao menos 6 caracteres!",
      ];
      this.confirmPasswordRules = [
        (v) => !!v || "Confirmação da senha é obrigatória",
        (v) => v === this.password || "As senhas devem ser iguais",
      ];
    },

    validateForm() {
      if (this.$refs.resetPassForm.validate()) {
        return true;
      }
      return false;
    },
    resetPassword() {
      if (this.validateForm()) {
        this.valueResetPassword.password = this.password;
        this.valueResetPassword.urlPassword = this.urlPassword;
        this.loading = true;
        this.$store
          .dispatch("resetPassword", this.valueResetPassword)
          .then((value) => {
            if (value.type == "ok") {
              this.resetForm();
              this.disabledFields = true;
              this.$store.dispatch("setNotification", {
                type: "success",
                text: "Senha atualizada com sucesso!",
              });
            } else {
              this.$store.dispatch("setNotification", {
                type: "error",
                text: value.error,
              });
            }
          })
          .catch((err) => {
            this.$store.dispatch("setNotification", {
              type: "error",
              text:
                "Ouve um erro ao processar sua solicitação! Tente novamente mais tarde.",
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    getResetUrl() {
      if (this.urlPassword) {
        this.loading = true;
        this.$store
          .dispatch("getResetUrl", this.urlPassword)
          .then((value) => {
            if (value.type == "ok") {
              this.disabledFields = false;
            } else {
              this.$store.dispatch("setNotification", {
                type: "error",
                text: value.msg,
              });
            }
          })
          .catch((err) => {
            this.$store.dispatch("setNotification", {
              type: "error",
              text: err,
            });
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.$store.dispatch("setNotification", {
          type: "error",
          text: "Url não localizada",
        });
      }
    },
  },
};
</script>
<style>
.signup-title {
  background-color: #0a1e8c;
  color: white;
}
.signup-form-input {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}
</style>
